import { toast } from 'sonner';
import logger from '../../utils/logger';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export const handlePasswordRegistration = async (e, { agreedToTerms, password, confirmPassword, passwordStrength, username, usernameAvailable, token, tokenData, navigate, setIsSubmitting, profileData }) => {
  e.preventDefault();

  if (!agreedToTerms) { toast.error('Please agree to the Terms and Conditions'); return; }
  if (password !== confirmPassword) { toast.error('Passwords do not match'); return; }
  if (passwordStrength.score < 4) { toast.error('Password must be at least 8 characters and include an uppercase letter, a lowercase letter, a number and a special character.'); return; }
  if (username && usernameAvailable === false) { toast.error('Username is already taken. Please choose another.'); return; }
  if (tokenData?.source === 'introduction' && !(profileData && profileData.country)) {
    toast.error('Please select your country to continue');
    return;
  }

  setIsSubmitting(true);
  try {
    const payload = { token: token, first_name: tokenData.first_name || 'User', last_name: tokenData.last_name || '', password: password };
    if (username) payload.username = username;
    if (profileData) {
      const cleaned = Object.fromEntries(
        Object.entries(profileData).filter(([, v]) => v && (!Array.isArray(v) || v.length > 0))
      );
      if (Object.keys(cleaned).length > 0) payload.profile = cleaned;
    }

    const response = await fetch(`${BACKEND_URL}/api/registration/complete`, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload)
    });
    const data = await response.json();
    if (!response.ok) throw new Error(data.detail || 'Registration failed');

    toast.success('Account created successfully! Redirecting to login...', { duration: 3000 });
    setTimeout(() => { navigate('/login?registered=true'); }, 2000);
  } catch (err) {
    logger.error('Registration error:', err);
    if (err.message.includes('already been used')) {
      toast.error('This registration link has already been used. Please log in instead.', { duration: 5000 });
      setTimeout(() => navigate('/login'), 3000);
    } else if (err.message.includes('already exists')) {
      toast.error('An account with this email already exists. Please log in instead.', { duration: 5000 });
      setTimeout(() => navigate('/login'), 3000);
    } else if (err.message.includes('expired')) {
      toast.error('This registration link has expired. Please request a new one.');
    } else {
      toast.error(err.message || 'Failed to create account. Please try again.');
    }
  } finally {
    setIsSubmitting(false);
  }
};
